import { IGetBannerReview } from './../model/types'

export const getBannerReview = (rest: string): IGetBannerReview => {
  console.log('rest', rest)

  switch (rest) {
    case 'gastorbaiter':
    case 'restoran-nani-29242':
      return {
        link: 'https://dostavka.nanirestaurant.ru/app?utm_medium=banner&utm_campaign=tapper',
        img: 'nanirestaurant.JPG',
        id: 4
      }
    case 'iiko2':
    case 'gamardghoba-21206':
    case 'gamardghoba-21201':
    case 'gamardghoba-21239':
    case 'kafe-gruzinskoi-kuhni-gamardghoba-21203':
    case 'gamardghoba-21223':
    case 'gamardghoba-22391':
    case 'gamardghoba-22398':
      return {
        link: 'https://dostavka.gamardzhoba.ru/app?utm_medium=banner&utm_campaign=tapper',
        img: 'gamardzhoba.JPG',
        id: 4
      }
    case 'jpandango-6667':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpantrubnaya&utm_medium=tapper_jpantrubnaya&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpan-ooo-mishka-6688':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpanzabelina&utm_medium=tapper_jpanzabelina&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpanmoti-6691':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpanmyasnitskaya&utm_medium=tapper_jpanmyasnitskaya&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpan-6700':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpanсhaayanova&utm_medium=tapper_jpanсhaayanova&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpan-18417':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpangruzinskaya&utm_medium=tapper_jpangruzinskaya&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpan-18403':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=ttapper_jpandmitrovka&utm_medium=tapper_jpandmitrovka&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'japan-pyatnickaya-14203':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpanpanpyatnitskaya&utm_medium=tapper_jpanpanpyatnitskaya&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'jpan-21032':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_jpanhamovniki&utm_medium=tapper_jpanhamovniki&tags=tapper',
        img: 'jpan.jpg',
        id: 4
      }
    case 'kook-6705':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=ttapper_kook&utm_medium=tapper_kook&tags=tapper',
        img: 'kook.png',
        id: 5
      }
    case 'kook-myasnickaya-6946':
      return {
        link: 'https://get.osmicards.com/anketa/0333SXP538CVV/get?type=1&utm_source=tapper_kook_myasnitskaya&utm_medium=tapper&tags=project',
        img: 'kook.png',
        id: 5
      }
    case 'ramen-6702':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_ramentsvetnoy&utm_medium=tapper_ramentsvetnoy&tags=tapper',
        img: 'ramen_2.png',
        id: 6
      }
    case 'ramenvinzavod-6944':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_ramenvinsavod&utm_medium=tapper_ramenvinsavod&tags=tapper',
        img: 'ramen_2.png',
        id: 6
      }
    case 'ramen-6703':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_ramenmyasnitskaya&utm_medium=tapper_ramenmyasnitskaya&tags=tapper',
        img: 'ramen_2.png',
        id: 6
      }
    case 'ramen-6704':
      return {
        link: 'https://refer.id/?bot=LBgroup_main_bot&platform=telegram&verbose_name=LB Group&n=105171&c=5964&utm_source=tapper_ramenpyatnitskaya&utm_medium=tapper_ramenpyatnitskaya&tags=tapper',
        img: 'ramen_2.png',
        id: 6
      }
    default:
      return {
        link: 'https://mfl.life',
        img: 'mistral.jpg',
        id: 8
      }
  }
}
